import { Link } from 'react-router-dom';
import SEOHead from '../../components/SEOHead';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function PrivacyPolicy() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://momsfirstcare.com';
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Privacy Policy - MomsFirstCare",
    "url": `${siteUrl}/privacy`,
    "description": "Privacy policy and data protection information for MomsFirstCare platform",
    "publisher": {
      "@type": "Organization",
      "name": "MomsFirstCare"
    },
    "datePublished": "2025-01-01",
    "dateModified": "2025-01-01"
  };

  const sections = [
    {
      title: 'Information We Collect',
      icon: 'ri-information-line',
      content: 'We collect information you provide directly, such as name, email, and search preferences when using our platform.'
    },
    {
      title: 'How We Use Your Information',
      icon: 'ri-settings-3-line',
      content: 'Your information helps us provide better healthcare facility recommendations and improve our services.'
    },
    {
      title: 'Data Security',
      icon: 'ri-shield-check-line',
      content: 'We implement security measures to protect your personal information from unauthorized access or disclosure.'
    },
    {
      title: 'Your Rights',
      icon: 'ri-user-settings-line',
      content: 'You can access, update, or delete your personal information at any time by contacting us.'
    },
    {
      title: 'Intellectual Property',
      icon: 'ri-copyright-line',
      content: 'All content, images, text, and data on MomsFirstCare are protected by copyright. All rights reserved © 2025.'
    },
    {
      title: 'Contact Us',
      icon: 'ri-mail-line',
      content: 'Questions about this policy? Email us.'
    }
  ];

  return (
    <>
      <SEOHead
        title="Privacy Policy - MomsFirstCare"
        description="Privacy policy and data protection information for MomsFirstCare. Learn how we collect, use, and protect your personal information."
        keywords="privacy policy, data protection, personal information, MomsFirstCare"
        canonical={`${siteUrl}/privacy`}
        schema={schema}
      />
      <div className="min-h-screen bg-gradient-to-br from-teal-50 via-blue-50 to-white">
        <Navbar />
        
        <div className="pt-32 pb-24 px-6 lg:px-8">
          <div className="max-w-3xl mx-auto">
            {/* Header */}
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-100 rounded-full mb-4">
                <i className="ri-shield-check-line text-teal-600"></i>
                <span className="text-sm font-medium text-teal-700">Legal Information</span>
              </div>
              <h1 className="text-4xl font-bold text-gray-900 mb-4">Privacy Policy</h1>
            </div>

            {/* Policy Sections */}
            <div className="space-y-6">
              {sections.map((section, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-all"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className={`${section.icon} text-xl text-teal-600`}></i>
                    </div>
                    <div>
                      <h2 className="text-xl font-bold text-gray-900 mb-2">
                        {section.title}
                      </h2>
                      <p className="text-base text-gray-700 leading-relaxed">
                        {section.content}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Copyright Notice */}
            <div className="mt-8 bg-gradient-to-r from-teal-50 to-blue-50 rounded-2xl p-6 border-2 border-teal-200">
              <div className="flex items-start gap-3">
                <i className="ri-copyright-line text-2xl text-teal-600 mt-1"></i>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">All Rights Reserved</h3>
                  <p className="text-sm text-gray-700">
                    © 2025 MomsFirstCare. All content, including images, text, graphics, healthcare data, 
                    and trademarks are protected by copyright law. Unauthorized use is prohibited.
                  </p>
                </div>
              </div>
            </div>

            {/* Back to Home */}
            <div className="mt-12 text-center">
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-6 py-3 bg-teal-600 text-white rounded-full font-semibold text-base hover:bg-teal-700 transition-all hover:shadow-lg shadow-teal-600/30 whitespace-nowrap"
              >
                <i className="ri-arrow-left-line"></i>
                <span>Back to Home</span>
              </Link>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}